import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Notice Message customisation
 * Returns styling for different notice types (info, warning, error, default)
 */
export const useNoticeCustomisation = () => {
  // Info notice customisation
  const { getField: getInfoNoticeField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.NOTICE_MESSAGE_SECTION_KEYS.INFO,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.NOTICE_MESSAGES,
  });

  // Warning notice customisation
  const { getField: getWarningNoticeField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.NOTICE_MESSAGE_SECTION_KEYS.WARNING,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.NOTICE_MESSAGES,
  });

  // Error notice customisation
  const { getField: getErrorNoticeField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.NOTICE_MESSAGE_SECTION_KEYS.ERROR,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.NOTICE_MESSAGES,
  });

  return {
    infoNoticeTextColor: getInfoNoticeField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
    infoNoticeBackgroundColor: getInfoNoticeField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR),

    warningNoticeTextColor: getWarningNoticeField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
    warningNoticeBackgroundColor: getWarningNoticeField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR),

    errorNoticeTextColor: getErrorNoticeField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
    errorNoticeBackgroundColor: getErrorNoticeField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR),
  };
};
